import { ProgramAccommodationTypeEnum } from '@koob/enums';

/**
 * A day of a version without a hotel does not always mean "nothing picked
 * yet": it can be settled with no accommodation at all, closed by a night
 * transfer, or left to a hotel booked outside KOOB. The editable panel tells
 * those apart, and the read view says the same thing on the same grey card,
 * otherwise comparing two versions shows a difference that never happened.
 */
export function getEmptyAccommodation({
  program,
  hotelBookedOnMyOwn,
  t,
}: {
  program: any;
  hotelBookedOnMyOwn?: boolean;
  t: (key: string) => string;
}): { label: string; variant: 'filled' | 'dashed' } {
  if (hotelBookedOnMyOwn) {
    return { label: t('compose.hotelWillBeBookedOnMyOwn'), variant: 'filled' };
  }

  switch (program?.accomodationType) {
    case ProgramAccommodationTypeEnum.NIGHT_TRANSFER:
      return {
        label: program?.accomodationExperience?.name,
        variant: 'filled',
      };
    case ProgramAccommodationTypeEnum.NO_ACCOMMODATION:
      return { label: t('compose.noAccomodation'), variant: 'filled' };
    default:
      // A hotel slot left empty, or a free accommodation whose choice was
      // never made.
      return { label: t('compose.noAccomodationSelected'), variant: 'dashed' };
  }
}

/**
 * §9 — a day always announces a departure city AND an arrival city, the
 * arrival following the effective end of the day (a retained transfer moves
 * it, KD-3548).
 */
export function getVersionDayLocations({
  experience,
  effectiveEndPosition,
}: {
  experience: any;
  effectiveEndPosition: any;
}): { startLocation: string | null; endLocation: string | null } {
  const startLocation = experience?.inCity
    ? `${experience.inCity.title}, ${experience.inCity.country?.title}`
    : null;

  const endLocation = effectiveEndPosition
    ? `${
        effectiveEndPosition.city ||
        effectiveEndPosition.name ||
        effectiveEndPosition.title ||
        ''
      }${effectiveEndPosition.country ? `, ${effectiveEndPosition.country}` : ''}`
    : null;

  return { startLocation, endLocation };
}
